import type { EventType } from './adTagEvents';
import { adTagEvents, convertAdTagEvent } from './adTagEvents';
import type { AdTagType } from './adTagTypes';
import { adTagTypes } from './adTagTypes';
import type { Config, DisplayEnum } from './types';
import { isRecognizedConfig } from './utils';

const permittedAdTagEvents: Record<AdTagType, Config<EventType>[]> = {
  BILLABLE: [adTagEvents.COMPLETE],
  NON_BILLABLE: [
    adTagEvents.START,
    adTagEvents.FIRSTQUARTILE,
    adTagEvents.MIDPOINT,
    adTagEvents.THIRDQUARTILE,
    adTagEvents.COMPLETE,
  ],
  CLICK: [adTagEvents.CLICK],
};

export function getPermittedAdTagEvents(tagTypeKey: AdTagType, lineItemBillableEvent?: string): Config<EventType>[] {
  // Billable Ad Tags should use Event/Position equal to Line Item BillableEvent when present
  if (tagTypeKey === adTagTypes.BILLABLE.key && lineItemBillableEvent) {
    const convertedBillableEvent: DisplayEnum<EventType> = convertAdTagEvent(lineItemBillableEvent);
    if (isRecognizedConfig(convertedBillableEvent)) {
      return [convertedBillableEvent];
    }
  }
  return permittedAdTagEvents[tagTypeKey];
}
